const DOMAIN_TITLES = {
  localhost: 'Goqqi Pro',
  '127.0.0.1': 'Goqqi Pro',
  'nhs-clinic.yasuqii.com': 'YasuQii Consultation',
};
const DEFAULT_TITLE = 'Goqqi Pro';

const DOMAIN_DESCRIPTIONS = {
  localhost: 'Goqqi Pro',
  '127.0.0.1': 'Goqqi Pro',
  'nhs-clinic.yasuqii.com': 'YasuQii Consultation',
};
const DEFAULT_DESCRIPTION = 'Goqqi Pro';

const DOMAIN_LOGO = {
  localhost: 'https://websitecdn.goqii.com/images/newimages/favicon.png',
  '127.0.0.1': 'https://websitecdn.goqii.com/images/newimages/favicon.png',
  'nhs-clinic.yasuqii.com': '/favicon_yasuQii.png',
};
const DEFAULT_LOGO = 'https://websitecdn.goqii.com/images/newimages/favicon.png';

export const setPageTitleByDomain = () => {
  const hostname = window.location.hostname;
  const title = DOMAIN_TITLES[hostname] || DEFAULT_TITLE;
  document.title = title;

  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', DOMAIN_DESCRIPTIONS[hostname] || DEFAULT_DESCRIPTION);
  }
  let favicon = document.querySelector("link[rel='icon']");
  if (favicon) {
    favicon.href = DOMAIN_LOGO[hostname] || DEFAULT_LOGO;
  }
  return title;
};
